import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    justify-content: center;
`;

export const Content = styled.div`
    text-align: justify;
    max-width:900px;
`;